var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { ErrorOutline, InfoOutlined, WarningAmberOutlined } from '@mui/icons-material';
import Text from '../Text';
import colors from '../../themes/colors';
import { getBannerColors } from '../../utils/banner/getBannerColors';
var getFooterStyle = function () { return "\n  align-items: center;\n  bottom: 0;\n  position: absolute;\n  width: 100%;\n  left: 0;\n  border-radius: 0;\n  border-left: none;\n  border-bottom: none;\n  border-right: 0;\n"; };
var BannerWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  ", "\n"], ["\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  ", "\n"])), function (props) { var _a; return (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : colors.neutral0; }, function (props) { var _a; return (_a = props.borderColor) !== null && _a !== void 0 ? _a : colors.neutral10; }, function (props) { return (props.footer ? getFooterStyle() : ''); });
var BannerBody = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  gap: 4px;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-flow: column;\n  gap: 4px;\n  justify-content: space-between;\n"])));
var mappings = {
    error: {
        borderColor: getBannerColors('error').borderColor,
        backgroundColor: getBannerColors('error').backgroundColor,
        icon: _jsx(ErrorOutline, { style: { color: colors.red60 } })
    },
    warning: {
        borderColor: getBannerColors('warning').borderColor,
        backgroundColor: getBannerColors('warning').backgroundColor,
        icon: _jsx(WarningAmberOutlined, { style: { color: colors.yellow50 } })
    },
    info: {
        borderColor: getBannerColors('info').borderColor,
        backgroundColor: getBannerColors('info').backgroundColor,
        icon: _jsx(InfoOutlined, { style: { color: colors.neutral20 } })
    },
    success: {
        borderColor: getBannerColors('success').borderColor,
        backgroundColor: getBannerColors('success').backgroundColor,
        icon: _jsx(InfoOutlined, { style: { color: colors.green60 } })
    }
};
var Banner = function (_a) {
    var type = _a.type, title = _a.title, body = _a.body, _b = _a.showIcon, showIcon = _b === void 0 ? true : _b, _c = _a.footer, footer = _c === void 0 ? false : _c, children = _a.children;
    var content = mappings[type];
    return (_jsxs(BannerWrapper, __assign({}, content, { footer: footer }, { children: [showIcon && content.icon, _jsxs(BannerBody, { children: [title ? _jsx(Text, __assign({ variant: "body1Semibold" }, { children: title })) : null, _jsx(Text, __assign({ variant: "body2" }, { children: body }))] }), children] })));
};
export default Banner;
var templateObject_1, templateObject_2;
